<template>
  <div class="footer">
    <h5 style="margin:auto">- Powered by <a href="https://github.com/One-Studio">One Studio</a> -</h5>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  clear: both;
  text-align: center;
  vertical-align: middle;
  margin: 30px auto 30px auto;
}
</style>
